import { Pipe, PipeTransform } from '@angular/core';

import { EvseStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

import { TranslateEnumPipeBase } from '@shared/pipes/translate-enum-pipe-base';

const KEY_PREFIX = 'enums.evse-status-capitalized';
export const EvseStatusKeyMapping: Record<EvseStatusStoreModelEnum, string> = {
  [EvseStatusStoreModelEnum.Charging]: `${KEY_PREFIX}.charging`,
  [EvseStatusStoreModelEnum.Queued]: `${KEY_PREFIX}.queued`,
  [EvseStatusStoreModelEnum.Available]: `${KEY_PREFIX}.available`,
  [EvseStatusStoreModelEnum.Faulted]: `${KEY_PREFIX}.faulted`,
  [EvseStatusStoreModelEnum.Maintenance]: `${KEY_PREFIX}.maintenance`,
  [EvseStatusStoreModelEnum.Unknown]: `${KEY_PREFIX}.unknown`,
};

@Pipe({
  name: 'appTranslateEvseStatusCapitalized',
  pure: false,
  standalone: true,
})
export class TranslateEvseStatusCapitalizedPipe extends TranslateEnumPipeBase<EvseStatusStoreModelEnum> implements PipeTransform {
  protected readonly valueTranslateKeyMap = EvseStatusKeyMapping;
}
